import { createActionTypes } from 'lib/utils/createActionTypes';

interface IUIConfigDuckState {
	isAppBarVisible: boolean;
}

export default class UIConfigDuck {
	public static initialState: IUIConfigDuckState = {
		isAppBarVisible: true,
	};

	public static duckName = 'UI/Configuration';

	public static actionTypes: any = createActionTypes(
		{
			isAppBarVisible: 'is_app_bar_visible',
			hideAppBar: 'hide_app_bar',
			showAppBar: 'show_app_bar',
		},
		UIConfigDuck.duckName,
	);

	/**
	 * Used to open Modal, set it's content and color
	 */
	public static showAppBar = () => dispatch => {
		document.body.classList.add('Modal-open');
		dispatch({
			type: UIConfigDuck.actionTypes.openModal,
			payload: { isAppBarVisible: true },
		});
	};

	/**
	 * Used to open Modal, set it's content and color
	 */
	public static hideAppBar = () => dispatch => {
		dispatch({
			type: UIConfigDuck.actionTypes.hideAppBar,
			payload: { isAppBarVisible: false },
		});
	};
	public static getOwnState = (state: IUIConfigDuckState) =>
		state[UIConfigDuck.duckName] || UIConfigDuck.initialState;

	public static isAppBarVisible(state) {
		return this.getOwnState(state).isAppBarVisible;
	}

	public static reducer(state = UIConfigDuck.initialState, action) {
		switch (action.type) {
			case UIConfigDuck.actionTypes.hideAppBar:
				return { ...action.payload };
			case UIConfigDuck.actionTypes.openAppBar:
				return { ...action.payload };
			default:
				return state;
		}
	}
}



// WEBPACK FOOTER //
// ./src/stores/ducks/ui/UIConfig.duck.ts